import { Settings } from "../../types";
import { useFlowPages } from "../../hooks/useFlowPages";

interface FormSettingsProps {
  settings: Settings;
}

export function FormSettings({ settings }: FormSettingsProps) {
  const FormComponent = useFlowPages({
    page: 'formSettings',
    props: {
      settings,
    }
  });

  return <>{FormComponent}</>;
}
